import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_NATIONALITIES } from '../types';
import { getNationalitiesPending, getNationalitiesFulfilled, getNationalitiesRejected } from '../actions/getNationalitiesActions';
import { sendApiRequest, notifyWarning, notifyError } from '../actions';
import generateError from '../utilities/generateError';
import { NATIONALITY_MESSAGES } from '../constants/nationalityMessages';

const createPayload = payload => ({
  method: 'get',
  url: 'nationality/get',
  onSuccess: [response => (response.data.length === 0 ? notifyWarning(NATIONALITY_MESSAGES.NOT_FOUND) : getNationalitiesFulfilled(response))],
  onError: [
    getNationalitiesRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getNationalitiesEpic$ = action$ => action$.pipe(
  ofType(GET_NATIONALITIES.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(getNationalitiesPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default getNationalitiesEpic$;


// WEBPACK FOOTER //
// ./src/epics/getNationalitiesEpic.js